import { Injectable } from '@angular/core';
import { } from 'googlemaps';
import { Observable } from 'rxjs';
import { IPlacesAutocompleteResult } from '@app/shared/models/places-autocomplete-result.model';
import { GoogleMapsLoader } from '@app/shared/services/map-loader/map-loader.service';
import { map } from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class PlacesAutocompleteService {
  private autocompleteService: google.maps.places.AutocompleteService;
  private sessionToken: google.maps.places.AutocompleteSessionToken;

  private lastData: IPlacesAutocompleteResult[];

  constructor(googleMapsLoader: GoogleMapsLoader) {
    googleMapsLoader.load()
      .then(_res => {
        this.autocompleteService = new google.maps.places.AutocompleteService();
        this.generateNewSessionToken();
      });
  }

  generateNewSessionToken(): void {
    this.sessionToken = new google.maps.places.AutocompleteSessionToken();
  }

  getPlacePredictions(term: string): Observable<IPlacesAutocompleteResult[]> {
    return new Observable(observer => {
      this.autocompleteService.getPlacePredictions(
        {
          input: term,
          types: ['(cities)'],
          componentRestrictions: { country: ['nl', 'be'] },
          sessionToken: this.sessionToken
        }, (data: google.maps.places.AutocompletePrediction[]) => {
          if (data) {
            const result = this.mapToAutoCompleteResult(data);
            this.lastData = result;
            observer.next(result);
            observer.complete();
          }
          if (!data) {
            observer.next(this.lastData);
            observer.complete();
          } else {
            observer.error(status);
          }
        });
    });
  }

  private mapToAutoCompleteResult(model: google.maps.places.AutocompletePrediction[]): IPlacesAutocompleteResult[] {
    return map(model, (x: google.maps.places.AutocompletePrediction) => {
      const result: IPlacesAutocompleteResult = {
        city: x.structured_formatting.main_text,
        country: x.structured_formatting.secondary_text,
        fullName: `${x.structured_formatting.main_text}, ${x.structured_formatting.secondary_text}`
      };
      return result;
    });
  }
}
